import React from 'react';

/** Visually joins its child Buttons into one segmented control. */
const ButtonGroup =({ className, children, ...rest }) => (
  <div role="group" className={['ui-btn-group', className].filter(Boolean).join(' ')} {...rest}>
    {children}
  </div>
);

export default ButtonGroup;
